import { Button, Modal } from 'avo-ui'
import icWarning from '../../../assets/images/ic-warning.svg'
import clsx from 'clsx'

const ModalConfirmation = ({
    className,
    show,
    onHide,
    description,
    totalData,
    isLoading,
    onConfirm,
    buttonConfirmText,
}) => {
    return (
        <Modal dialogClassName={'max-w-[328px]'} contentClassName={'rounded-xl'} show={show} onHide={onHide}>
            <>
                <div className={clsx('flex flex-col space-y-4 items-center p-10', className)}>
                    <img src={icWarning} alt={'ic-warning'} className={'w-12 h-12'} />
                    <p className={'font-semibold'}>Confirmation</p>
                    <p className={'text-neutral-70 text-center'}>{description}</p>
                    {totalData ? <p>Total Data: {totalData}</p> : ''}
                </div>
                <div className={'flex flex-row px-6 py-3 border-t space-x-3 justify-center'}>
                    <Button type={'outline'} title={'Cancel'} onClick={onHide} />
                    <Button title={buttonConfirmText || 'Submit'} loading={isLoading} onClick={onConfirm} />
                </div>
            </>
        </Modal>
    )
}

export default ModalConfirmation
